import { DatasourceTypeV2 } from "src/api/graphql/graphql.ts"
import Databricks from "src/global/assets/images/databricks.png"
import Pandas from "src/global/assets/images/pandas.png"
import Postgres from "src/global/assets/images/postgresql.png"
import Redshift from "src/global/assets/images/redshift.png"
import Snowflake from "src/global/assets/images/snowflake.svg?url"
import Spark from "src/global/assets/images/spark.png"
import SQL from "src/global/assets/images/sql.svg?url"
import SQLite from "src/global/assets/images/sqlite.png"
import BigQuery from "src/global/assets/images/big-query.svg?url"
import Neon from "src/global/assets/images/neon.svg?url"
import Citus from "src/global/assets/images/citus.svg?url"
import Alloy from "src/global/assets/images/alloy.svg?url"
import AmazonAurora from "src/global/assets/images/amazon-aurora.svg?url"
import AzureBlobStorage from "src/global/assets/images/azure-blob-storage.svg?url"
import GoogleCloudStorage from "src/global/assets/images/google-cloud-storage.svg?url"
import AmazonS3 from "src/global/assets/images/amazon-s3.svg?url"

type DataSourceImageLogo = DatasourceTypeV2

export type PandasDataSourceVariant = "PANDAS_GCS" | "PANDAS_ABS" | "PANDAS_S3" | "PANDAS_FILESYSTEM" | "PANDAS_DBFS"
export type SparkDataSourceVariant = "SPARK_FILESYSTEM" | "SPARK_DBFS" | "SPARK_S3" | "SPARK_ABS" | "SPARK_GCS"

export type PaintedDoorDataSource = "BIGQUERY" | PandasDataSourceVariant | SparkDataSourceVariant

const images: Record<DataSourceImageLogo, string> = {
  ALLOY: Alloy,
  AURORA: AmazonAurora,
  CITUS: Citus,
  DATABRICKS_SQL: Databricks,
  NEON: Neon,
  SPARK: Spark,
  PANDAS: Pandas,
  POSTGRES: Postgres,
  REDSHIFT: Redshift,
  SQL: SQL,
  SQLITE: SQLite,
  SNOWFLAKE: Snowflake,
}

const pandasImages: Record<PandasDataSourceVariant, string> = {
  PANDAS_GCS: GoogleCloudStorage,
  PANDAS_ABS: AzureBlobStorage,
  PANDAS_S3: AmazonS3,
  PANDAS_FILESYSTEM: Pandas,
  PANDAS_DBFS: Pandas,
}

const sparkImages: Record<SparkDataSourceVariant, string> = {
  SPARK_FILESYSTEM: Spark,
  SPARK_DBFS: Spark,
  SPARK_S3: AmazonS3,
  SPARK_ABS: AzureBlobStorage,
  SPARK_GCS: GoogleCloudStorage,
}

type NewImages = Record<PaintedDoorDataSource, string>

const newImages: NewImages = {
  BIGQUERY: BigQuery,
  ...pandasImages,
  ...sparkImages,
}

export function getImageLogo(
  name: DataSourceImageLogo | PaintedDoorDataSource,
  isDSPaintedDoorsEnabled?: boolean,
): string {
  if (isDSPaintedDoorsEnabled) {
    const allImages = { ...images, ...newImages }
    return allImages[name]
  }

  return images[name as DataSourceImageLogo]
}
